import React from 'react'
import './article.css'
import bannerImage3 from "./assets/1024px-Agency_headquarters_Graphic.jpg"
import Header from './Header'
import DelayModel from './Canvas/DelayModel'
import FOAK from './Post3Assets/FOAK'

const Post3 = () => {
  return (
    <div>
      <Header title="Killing Nuclear Power" image={bannerImage3}/>
      <article>
        <header>
          <p>By <strong>Milo Peterson</strong> | <time dateTime="2025-06-2">July 20, 2025</time></p>
        </header>

        <section>
          <p>
            Nuclear power is ruining our society. I just can't stand those big concrete towers that I don't actually live near. And the steam that pours from them has GOT to be 
            terrible for the environment. They also use URANIUM — that stuff is dangerous; I absolutely can't have my house powered by it. Worst of all, it's probably raising my electric bill — 
            not sure, but I bet it is. Something has got to be done about these ludicrous fiends building nuclear reactors. If something isn't being done, I'll just do it myself.
          </p>
        </section>

        <section>
          <h2>How to Topple an Industry</h2>

          <p>
            In order to bring the tyrannical industry toppling down, first, you need to understand a few things. The only way to truly stop an industry — legally, that is — 
            like nuclear power is to take all of the money away. We're seeing it now in the coal industry. The profitability of coal went down, and the whole industry started to go with it.
            In the 2000s, the U.S. had some 600 coal plants in operation. Today, there are only around 200 still open. Not coincidentally, around 2012, solar, wind, natural gas, and geothermal power had all 
            nearly halved the price per kWh of coal.
          </p>
          <p>
            So you'll be using cost to take down the industry. Make nuclear energy too expensive, and there’s no reason for anyone to use that abhorrent form of power. 
            There are two simple ways you can pull this off: first, by exacerbating the weakness that is high CAPEX and delays; second, by going to another extremely corrupt institution for help — the government.
          </p>
        </section>

        <section>
          <h2>Delay Costs</h2>
          <p>The first and simplest way to stop nuclear power is delays.</p>
          <DelayModel/>
          <p>
            Let’s say there was a plan for a nuclear plant that would cost about $15 billion. Then it got pushed back and delayed for about seven years. 
            That would make the new price just under $30 billion. Georgia Power's Vogtle reactor, brought online in March of this year, was originally supposed to cost 
            $15 billion but got delayed seven years. Now, you need to spend $20 billion more!
          </p>
          <p>
            Vogtle is a truly bad example of delays that even took Westinghouse into bankruptcy — something to look up to. Maybe you don't actually have to lift a finger; the whole 
            industry’s already bringing itself down. This does serve as a great example of how you should proceed. With enough delays, you could run even the most 
            bloated of investors out of business until nobody could justify the risk of nuclear energy.
          </p>
        </section>

        <section>
          <h2>Stalling for Money</h2>

          <p>
            The question is now: how do I delay a reactor for five to ten years? First, you need to understand where delays come from. 
          </p>
          <p>
            A great place to look for inspiration is the Vogtle plant. So many different things went wrong and contributed to that epic failure, so we have a lot to work with.
            The first — and perhaps most important — factor was the use of a new AP1000 reactor. While there are AP1000 reactors around the world, this was the first built in the U.S.
            For first-of-a-kind reactors, there are dozens of permits, regulations, infrastructure, and design and engineering verifications you have to jump through to get 
            the job done. So, all you need to do is sell your new, innovative, and high-tech design to companies and get them to use it. The crazy thing is, your design could be 
            far and away the best on the market, but it will still cause huge overruns. And, if you want to really get it done, you explain that you really support the industry but 
            need it to be the best and most advanced it can be.
          </p>

          <h4>Four of the most recent first-of-a-kind reactors:</h4>
          <FOAK/>

          <p>
            Side note: I feel like I do have to mention that, in all seriousness, FOAK reactors are a necessary part of the design process. While infrastructure and 
            other roadblocks make the first of any design incredibly costly and complex, it’s the only way to improve technologically. But it is also very, very hard to have a production, first-of-a-kind, and expect on-time and on-budget performance. Ok, going back into character.
          </p>

          <p>
            If you don't want to make up new reactor types, you could just go after the management. Poor management is consistently a major factor in both delays and overruns. 
            Just insert yourself into upper management and make a few poor decisions.      
          </p>

          <p>
            You now have a couple of ways to ruin Westinghouse's day, but one of these alone doesn't necessarily do the trick. It also doesn't need to. 
            All you need to do is delay a fuel shipment by a few weeks, have some clerical error delay construction for a few days, or change the manager of the 
            project to delay it another few days. All these little delays affect the entire project, punching way above their weight. So you don't need the company to 
            go bankrupt or have some massive lawsuit that delays it five years — you just need to incrementally slow down the construction process, and the costs will start piling up.
          </p>
        </section>

        <section>
          <h2>Regulations</h2>
          <p>
            The second way that you could disrupt the nuclear industry involves the evil entity that takes half my paycheck every week: the government — as a student who makes like $50 a week, they don't take much, but it's still a grievous offense! 
            We know regulation’s the best way to stifle an industry — it stifles my paycheck plenty — because the government has been suffocating the nuclear industry for years.
            Once again, we're already headed in the right direction. What you need to do is use the bureaucracy for what's important to you, your neighborhood, your family, nature, and your health.
            Once you’re sure, beyond a shadow of a doubt, that nuclear energy isn't negatively impacting any of those things, well, you'll be happy — but the nuclear industry definitely won't.
          </p>

          <p>
            There is a chance of weapon proliferation if dangerous elements get out. There are potential health risks with hazardous waste. There are numerous 
            risks associated with such a complex industry working on this scale. 
            What you do is look at every item on the balance sheet and make it the safest, most reviewed list this side of the Milky Way. For fuel, you look at mining, transport, interstate transit, rail safety, storage, and push to perfection. The same trick works for coal:
            stop the mining, the shipping, the use, the burning, the ash. 
          </p>

          <p>
            There are hundreds of other ways to mess up the nuclear industry with regulations. You could require more permits, mandate an egregious number of engineers in plants, or require inspections every other hour. Oh wait — they did most of those already. 
            In all seriousness, there are many ways the government can and is stifling the nuclear industry. Some of this is with bad intentions, such as 
            fossil fuel lobbyists furthering their mandates. 
          </p>

          <p>
            The thing is, most of these — besides the lobbyists — are actually good ideas. As neighbors, friends, and family members, we all have a right to want what's safest. 
            The problem isn't extra safety; it's when it goes too far. When the NRC's objective stops being to promote nuclear energy and instead regulate and promote safety, it sounds great. 
            In reality, the NRC went from promoting nuclear to actively opposing it — and that right there is the issue. There is a complex and thin balance that needs to be struck in order 
            to both keep people safe and not suffocate one of the largest sources of green energy. Oh, unless, of course, you absolutely despise the nuclear industry. In that case, you can regulate to your heart’s desire. 
          </p>
        </section>

        <section>
          <h2>Conclusion</h2>
          <p>
            The nuclear industry is in trouble. Not that anyone is truly enough of a supervillain to do any of the things on this list, but they are huge weaknesses in the industry. 
            And that sucks, because nuclear energy is one of the biggest sources of green energy — more reliable than solar or wind, and more abundant than hydro or geothermal — nuclear 
            is the future of green energy.
          </p>
          <p>
            There is a silver lining. Of all the problems I mentioned, a technological ceiling was not one of them. Nuclear energy is limited entirely by us humans. 
            While solar power is still incredibly useful, it’s somewhat plateauing technologically. Nuclear still has a long way to go, and if we can fix a lot of the problems 
            within the industry, it could be a pillar of our power supply in a few decades.
          </p>
        </section>

<section>
  <h2>References</h2>

  National Academies of Sciences, Engineering, and Medicine. 
  <em>Laying the Foundation for New and Advanced Nuclear Reactors in the United States.</em> 
  The National Academies Press, 2023, &nbsp;
  <a href="https://nap.nationalacademies.org/read/26630/chapter/8" target="_blank" rel="noreferrer">
    https://nap.nationalacademies.org/read/26630/chapter/8
  </a>.
  <br /><br />

  Westinghouse Electric Company LLC. “Shaping Tomorrow’s Energy | Westinghouse Nuclear.” 
  <em>Westinghouse Nuclear</em>, 2025, &nbsp;
  <a href="https://westinghousenuclear.com" target="_blank" rel="noreferrer">
    https://westinghousenuclear.com
  </a>.
  <br /><br />

  World Nuclear Association. “Reactor Database – Summary.” 
  <em>World Nuclear Association</em>, 2025, &nbsp;
  <a href="https://world-nuclear.org/nuclear-reactor-database/summary" target="_blank" rel="noreferrer">
    https://world-nuclear.org/nuclear-reactor-database/summary
  </a>.
</section>


        <footer>
          
        </footer>
      </article>
    </div>
  )
}

export default Post3
